import React from 'react';
import Card from 'lib/components/Card/Card';
import { ReportHeader } from '../components/ReportHeader';
import ProductRevenueBarChart from '../components/ProductRevenueBarChart';
import ProductCategoryCharts from '../components/ProductCategoryCharts';

export function ProductsTab() {
  return (
    <Card>
      <ReportHeader title="Products" />
      <div className="p-6">
        <div className="flex flex-col gap-8">
          <ProductRevenueBarChart />
          <ProductCategoryCharts />
        </div>
      </div>
    </Card>
  );
}
